import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { UsersService } from '../../../@core/utils';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-checkbox-renderer',
    template: `
        <input
            type="checkbox"
            style="margin-top: 0.25rem"
            (click)="checkedHandler($event)"
            [checked]="params.value"
            [disabled]="isDisabled$ | async"
        />
    `,
    standalone: true,
    imports: [AsyncPipe],
})
export class CheckboxRendererComponent implements ICellRendererAngularComp {
    public params: any;
    public isDisabled$: Observable<boolean> = this.usersService.currentUserPerimeterPermissions$.pipe(
      map((permissions) => permissions.filter((permission) => !!permission.read_only).map((permission) => permission.perimeter)),
      map((readOnlyPerimeterIds) => readOnlyPerimeterIds?.includes(Number(this.params?.data?.site))),
    );

    constructor(
      private usersService: UsersService,
    ) { }

    agInit(params: any): void {
      this.params = params;
    }

    checkedHandler(event) {
      const checked = event.target.checked;
      const colId = this.params.column.colId;
      this.params.node.setDataValue(colId, checked);
    }

    refresh(): boolean {
      return false;
    }
}
